import { render, staticRenderFns } from "./ApplyChangesModal.vue?vue&type=template&id=76e1a954&scoped=true&"
import script from "./ApplyChangesModal.vue?vue&type=script&lang=js&"
export * from "./ApplyChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./ApplyChangesModal.vue?vue&type=style&index=0&id=76e1a954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e1a954",
  null
  
)

export default component.exports